export enum ApiError {
  InvalidInput = 'invalid_input',
  NotFound = 'not_found',
  ServerError = 'server_error',
  Forbidden = 'forbidden',
  Unauthorized = 'unauthorized',
  GoogleAccountWithNoEmail = 'google_account_with_no_email',
  GoogleAccountNotVerified = 'google_account_not_verified_cannot_merge',
  GoogleTokenInvalid = 'google_token_invalid',
  TokenExpired = 'token_expired',
  PasswordNotSecure = 'password_not_secure',
  FacebookTokenInvalid = 'facebook_token_invalid',
  FacebookMissingEmailScope = 'facebook_missing_email_scope',
  FacebookAccountWithNoEmail = 'facebook_account_with_no_email',
  FacebookAccountNotMatching = 'facebook_account_not_matching',
  NotImplemented = 'not_implemented',
  FiscalCodeProfileMismatch = 'fiscal_code_profile_mismatch',
  FiscalCodeInvalid = 'fiscal_code_invalid',
  OrderMissingData = 'order_missing_data',
  NotEnuoghtTimeElapseSinceLastAttempt = 'not_enought_time_elapse_since_last_attempt',
  PasswordResetCodeExpired = 'password_reset_code_expired',
  PasswordResetWrongCode = 'password_reset_wrong_code',
  ProductMissingBackendConfiguration = 'product_missing_backend_configuration',
  UniqueProductIsAlreadyInCart = 'unique_product_is_already_in_cart',
  UnknownPricingStrategy = 'unknown_pricing_strategy',
  CartEmpty = 'cart_empty',
  CartMustReferASingleOrder = 'cart_must_refer_a_single_order',
  UnrecognizedPaymentCurrency = 'unrecognized_payment_currency',
  CannotAddPurchaseToProvidedOrder = 'cannot_add_purchase_to_provided_order',
  PayPalCompletingUnkownTransaction = 'paypal_completing_unknown_transaction',
  CartItemMissingOrderId = 'cart_item_missing_order_id',
  ProductCanBePurchasedOnlyOncePerOrder = 'product_can_be_purchased_only_once_per_order',
  InvalidOrderStatusForProduct = 'invalid_order_status_for_product',
  NotEnoughTimeBeforeEta = 'not_enough_time_before_eta',
  CannotDeleteUser = 'cannot_delete_user',
  CannotCancelNotFinalizedPurchase = 'cannot_cancel_not_finalized_purchase',
  DoorbellTooFarFromAddress = 'doorbell_too_far_from_address',
  NewAddressMustHaveSameTerritoryId = 'new_address_must_have_same_territoryId',
  IndaboxPdrLowQuality = 'indabox_pdr_low_quality',
  IndaboxPdrTooFarFromDeliveryAddress = 'indabox_pdr_too_far_from_delivery_address',
  WrongCredentials = 'wrong_credentials',
  orderDoesNotBelongToCustomer = 'order_does_not_belong_to_customer',
}

export type ErrorModel = {
  error: ApiError;
  message?: string;
};
